import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { CoreService } from './../../base/core';
import { ServiceRoute } from '../../base/service-route';
import { CommonHttpOption } from '../../base/common-http-option';
import { IRoleGroup } from 'src/app/interfaces/role-group';

@Injectable({
  providedIn: 'root'
})
export class GroupRoleService {

  constructor(
    private coreService:CoreService
  ) { }
  
  getById(id:number):Observable<any>{
    return this.coreService.get(ServiceRoute.groupRole.getById+id,new CommonHttpOption().headers);
  }

  save(data:IRoleGroup):Observable<any>{
    return this.coreService.post(ServiceRoute.groupRole.save,data,new CommonHttpOption().headers);
  }

}
